import { SReducer } from "servisofts-model";

export default class Reducer extends SReducer {
    
  
}